import React, { forwardRef } from 'react';
import { SDatePicker } from './DatePicker.styles';
import { DatePickerProps } from './DatePicker.types';

const DatePicker = forwardRef<any, DatePickerProps>(({ ...props }, ref) => {
  return <SDatePicker ref={ref} {...props} />;
});

DatePicker.displayName = 'DatePicker';

export { DatePicker };
export default DatePicker;
